var map = {
	"./Paper1/PP1-4K.png": 239,
	"./Paper1/PP1-5K.png": 240,
	"./Paper1/PP1-8K.png": 241,
	"./Paper1/PP1-GalaxyS8.png": 242,
	"./Paper1/PP1-HD.png": 243,
	"./Paper1/PP1-M.png": 92,
	"./Paper1/PP1-MacBook.png": 244,
	"./Paper1/PP1-Smartphone.png": 245,
	"./Paper1/PP1-Tablet.png": 246,
	"./Paper1/PP1-Twitter.png": 247,
	"./Paper1/PP1-UltraWide.png": 248,
	"./Paper2/PP2-4K.png": 249,
	"./Paper2/PP2-5K.png": 250,
	"./Paper2/PP2-8K.png": 251,
	"./Paper2/PP2-GalaxyS8.png": 252,
	"./Paper2/PP2-HD.png": 253,
	"./Paper2/PP2-M.png": 93,
	"./Paper2/PP2-MacBook.png": 254,
	"./Paper2/PP2-Smartphone.png": 255,
	"./Paper2/PP2-Tablet.png": 256,
	"./Paper2/PP2-Twitter.png": 257,
	"./Paper2/PP2-UltraWide.png": 258,
	"./Paper3/PP3-4K.png": 259,
	"./Paper3/PP3-5K.png": 260,
	"./Paper3/PP3-8K.png": 261,
	"./Paper3/PP3-GalaxyS8.png": 262,
	"./Paper3/PP3-HD.png": 263,
	"./Paper3/PP3-M.png": 94,
	"./Paper3/PP3-MacBook.png": 264,
	"./Paper3/PP3-Smartphone.png": 265,
	"./Paper3/PP3-Tablet.png": 266,
	"./Paper3/PP3-Twitter.png": 267,
	"./Paper3/PP3-UltraWide.png": 268,
	"./Paper4/PP4-4K.png": 269,
	"./Paper4/PP4-5K.png": 270,
	"./Paper4/PP4-8K.png": 271,
	"./Paper4/PP4-GalaxyS8.png": 272,
	"./Paper4/PP4-HD.png": 273,
	"./Paper4/PP4-M.png": 95,
	"./Paper4/PP4-MacBook.png": 274,
	"./Paper4/PP4-Smartphone.png": 275,
	"./Paper4/PP4-Tablet.png": 276,
	"./Paper4/PP4-Twitter.png": 277,
	"./Paper4/PP4-UltraWide.png": 278,
	"./Paper5/PP5-4K.png": 279,
	"./Paper5/PP5-5K.png": 280,
	"./Paper5/PP5-8K.png": 281,
	"./Paper5/PP5-GalaxyS8.png": 282,
	"./Paper5/PP5-HD.png": 283,
	"./Paper5/PP5-M.png": 96,
	"./Paper5/PP5-MacBook.png": 284,
	"./Paper5/PP5-Smartphone.png": 285,
	"./Paper5/PP5-Tablet.png": 286,
	"./Paper5/PP5-Twitter.png": 287,
	"./Paper5/PP5-UltraWide.png": 288,
	"./Paper6/PP6-4K.png": 289,
	"./Paper6/PP6-5K.png": 290,
	"./Paper6/PP6-8K.png": 291,
	"./Paper6/PP6-GalaxyS8.png": 292,
	"./Paper6/PP6-HD.png": 293,
	"./Paper6/PP6-M.png": 97,
	"./Paper6/PP6-MacBook.png": 294,
	"./Paper6/PP6-Smartphone.png": 295,
	"./Paper6/PP6-Tablet.png": 296,
	"./Paper6/PP6-Twitter.png": 297,
	"./Paper6/PP6-UltraWide.png": 298,
	"./Paper7/PP7-4K.png": 299,
	"./Paper7/PP7-5K.png": 300,
	"./Paper7/PP7-8K.png": 301,
	"./Paper7/PP7-GalaxyS8.png": 302,
	"./Paper7/PP7-HD.png": 303,
	"./Paper7/PP7-M.png": 98,
	"./Paper7/PP7-MacBook.png": 304,
	"./Paper7/PP7-Smartphone.png": 305,
	"./Paper7/PP7-Tablet.png": 306,
	"./Paper7/PP7-Twitter.png": 307,
	"./Paper7/PP7-UltraWide.png": 308,
	"./Paper8/PP8-4K.png": 309,
	"./Paper8/PP8-5K.png": 310,
	"./Paper8/PP8-8K.png": 311,
	"./Paper8/PP8-GalaxyS8.png": 312,
	"./Paper8/PP8-HD.png": 313,
	"./Paper8/PP8-M.png": 99,
	"./Paper8/PP8-MacBook.png": 314,
	"./Paper8/PP8-Smartphone.png": 315,
	"./Paper8/PP8-Tablet.png": 316,
	"./Paper8/PP8-Twitter.png": 317,
	"./Paper8/PP8-UltraWide.png": 318
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 323;


//////////////////
// WEBPACK FOOTER
// ./src/Assets ^\.\/Paper.*\.png$
// module id = 323
// module chunks = 0